export default __webpack_public_path__ + "static/media/antaraja.d6c17c8c.png";